"use client";

import { Icon, ospThemes } from "@ospweb/sdk-ui";

import React from "react";
import { cn } from "utils";

export interface LoadingButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * 是否处于 loading 状态
   */
  loading?: boolean;
  /**
   * 子元素类名
   */
  childrenClassName?: string;
}

export function LoadingButton({
  loading = false,
  disabled,
  className,
  children,
  type = "button",
  childrenClassName,
  ...rest
}: LoadingButtonProps) {
  const isDisabled = disabled ?? loading;

  return (
    <button
      aria-label="Loading Button"
      data-openreplay-label="login_loadingbutton_click"
      id="btn-loading-button"
      {...rest}
      type={type}
      disabled={isDisabled}
      data-loading={loading}
      className={cn("group", className)}
    >
      <span className={cn("group-loading:hidden", childrenClassName)}>
        {children}
      </span>
      <Icon
        name="ic_loading2"
        size={20}
        color={ospThemes.colors.content_primary}
        className={cn("hidden animate-spin group-loading:block")}
      />
    </button>
  );
}
